import { useEffect, useState, useRef } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import Button from "../../../Button/component";
import Icon from "../../../Icon";
import { fireLoadClickedAnalytics } from "../../../PageAnalytics/PageAnalytics";
import { useDispatch } from "react-redux";

const INITIAL_PAGE_NUMBER = 2;

const LoadMore = ({ fetchFunction = () => {} }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [nextPage, setNextPage] = useState(INITIAL_PAGE_NUMBER);
    const isMountedRef = useRef(true);
    const dispatch = useDispatch();

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    useEffect(() => {
        if (isLoading) {
            dispatch(fetchFunction({ page: nextPage })).then(() => {
                if (!isMountedRef.current) return;
                setNextPage((nextPage) => nextPage + 1);
                fireLoadClickedAnalytics();
            });
        }
    }, [isLoading]);

    useEffect(() => {
        setIsLoading(false);
    }, [nextPage]);

    const pageNumber = nextPage - 1;

    const loadMoreClasses = classNames({
        [`sclt-loadmore${pageNumber}`]: true,
        loadMore: true,
        loading: isLoading,
    });

    const label = isLoading ? "Loading..." : "Load More";
    const loader = isLoading ? <div className="loader"></div> : null;
    const icon = <Icon type="chevron" />;

    return (
        <Button
            disabled={isLoading}
            onClick={() => setIsLoading(true)}
            className={loadMoreClasses}
            label={label}
            loader={loader}
            icon={icon}
        />
    );
};

LoadMore.prototypes = {
    fetchFunction: PropTypes.func,
};

export default LoadMore;
